import { render, staticRenderFns } from "./MyInvigilate.vue?vue&type=template&id=65cc2700&scoped=true&"
import script from "./MyInvigilate.vue?vue&type=script&lang=js&"
export * from "./MyInvigilate.vue?vue&type=script&lang=js&"
import style0 from "./MyInvigilate.vue?vue&type=style&index=0&id=65cc2700&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc2700",
  null
  
)

export default component.exports